module.exports = __webpack_public_path__ + "static/media/gabriel.502df207.gif";